
import 'react-app-polyfill/stable';
import 'core-js';
import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import { Provider } from 'react-redux';
import store from './store';
import { AuthProvider } from './services1/auth/useAuth';

createRoot(document.getElementById('root')).render(
  <AuthProvider>
  <Provider store={store}>
      <App />
  </Provider>
  </AuthProvider>,
);


